<main id="proof-reader">
  <div class="container-fluid hero-bg">
    <app-header></app-header>

    <div class="container mt-5">
      <div class="row text-center justify-content-center">
        <div class="col-lg-9 col-md-9 col-12 mb-4">
          <h1 class="heading">Online Proofreader</h1>
          <p class="description">
            Get an online proofreader to spot mistakes in your essays, papers
            and documents instantly. Polish your writing with our proofreading
            tool like a pro.
          </p>
        </div>
      </div>
    </div>

    <section class="mx-auto" style="max-width: 1320px; min-height: 530px;">
      <ng-template #landerContainer></ng-template>
    </section>
    <!-- <section class="container">
      <div class="editor-card">
        <p
          class="text-left success-msg"
          *ngIf="got_recpatcha"
          [ngStyle]="{
            color: color,
            'background-color': '#f8d7da',
            padding: '2px'
          }"
        >
          <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
          {{ recaptcha_message }}
        </p>

        <div class="row-1">
          <div class="icon-bar">
            <div
              class="icon-bar-img"
              id="uploadFileS"
              value="Browse"
              style="cursor: pointer"
              onclick="document.getElementById('upload').click();"
            >
              <app-icons-free-tools [name]="'pcIcon'" />
              <input
                id="upload"
                data-name="upload-element"
                #fileInput
                accept=".txt,.doc,.docx,.pdf,.odt,.rtf,.tex"
                type="file"
                (change)="uploadFileSaveRedirect($event)"
              />
            </div>
            <div
              class="icon-bar-img"
              style="cursor: pointer"
              (click)="openDropboxChooser()"
            >
              <app-icons-free-tools [name]="'dropboxIcon'" />
            </div>
            <div
              class="icon-bar-img"
              style="cursor: pointer"
              (click)="gDriveUpload()"
            >
              <app-icons-free-tools [name]="'googleIcon'" />
            </div>
          </div>

          <div class="flex-1">
            <div style="position: relative">
              <quill-editor
                id="editor"
                [(ngModel)]="homeText"
                [modules]="editorModules"
                [theme]="'snow'"
                (onEditorCreated)="onEditorCreated($event)"
                class="typing-editor px-3"
                id="editor"
                #editor
                style="overflow-y: auto; overflow-x: hidden"
                (click)="onclickeditor($event)"
                [(ngModel)]="text"
                (onEditorCreated)="onHandleFormatting($event)"
                (onContentChanged)="count_Words_Character2()"
                placeholder=""
              >
              </quill-editor>

              <div *ngIf="showParagraph" class="editSectionDiv">
                <div *ngFor="let content of contentArray">
                  <app-icons-free-tools [name]="'checktextIcon'" />
                  <h3 class="card-1h2">{{ content.header }}</h3>
                  <p class="paragraph">{{ content.paragraph }}</p>
                  <div class="upload-buttons">
                    <button
                      [ngClass]="{
                        paste: button.text === 'Sample Text',
                        click: button.text === 'Paste Text',
                        'default-class': true
                      }"
                      *ngFor="let button of content.buttons"
                      class="textButtons"
                      (click)="executeAction(button.action)"
                    >
                      <app-icons-free-tools [name]="button.icon" />{{
                        button.text
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <span *ngIf="char_count !== 0">
                <app-icons-free-tools
                  [name]="'deleteIcon'"
                  (click)="deleteText()"
                  class="icon-del"
                />
              </span>
              <div class="progress-loader-div">
                <div class="progress-loader" *ngIf="loaderAlert"></div>
              </div>
              <div class="bottom-icon">
                <div class="word-char">
                  <span class="wordCount">
                    Words: {{ char_count === 0 ? 0 : word_count }}
                  </span>
                  <span class="wordCount"
                    >Total Characters: {{ char_count }}</span
                  >
                </div>

                <div *ngIf="captchaVisible" class="captcha-modal-overlay">
                  <div class="captcha-modal">
                    <div
                      id="recaptcha-container"
                      class="recaptcha-container"
                      data-size="compact"
                      data-theme="light"
                    ></div>
                  </div>
                </div>

                <div class="">
                  <button
                    class="btn-Proofread buton"
                    (click)="handleButtonClick()"
                  >
                    Proofread Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->
  </div>
  <section class="container margin-top-bottom">
    <div class="row-5">
      <div class="">
        <h2 class="headings sm-screen">Introduction to Online Proofreader</h2>
        <p class="paragraph sm-screen">
          An online proofreader works instantly to identify and fix mistakes in
          essays, papers, or documents on the spot. It proofreads grammatical,
          spelling, and punctuation errors by analyzing the text to ensure the
          professionalism in your content.
          <br />
          This proofreading facility highlights mistakes within the text and
          allows users to review and correct them quickly. The proofreading
          process on our platform is totally efficient, user-friendly and
          hassle-free.
        </p>
      </div>
      <div class="proof-reader">
        <img
          src="/assets/images/proof-reader/1920-screen.webp"
          style="max-width: 100%"
          srcset="
            /assets/images/proof-reader/768-screen.webp 768w,
            /assets/images/proof-reader/480-screen.webp 480w,
            /assets/images/proof-reader/320-screen.webp 320w
          "
          class="img-proofread"
          sizes="
                (max-width: 425px) 320px,
                (min-width: 425px) and (max-width: 550px) 480px,
                (min-width: 550px) and (max-width: 2560px) 768px,
                1080px"
          alt="proof-reader"
          width="528"
          height="470"
        />
      </div>
    </div>
  </section>

  <div class="container mt-5">
    <app-premium />
  </div>

  <section class="container margin-top-bottom">
    <div class="row text-center justify-content-center">
      <div class="col-lg-8 col-md-9 mb-4">
        <h2 class="headings">How to Use Our Proofreading Tool?</h2>
        <p class="paragraph">
          The <a href="/online-proofreader"> proofreading tool</a> by GrammarIn
          has made the proofreading process the easiest. It involves a few steps
          described below.
        </p>
      </div>
    </div>

    <div class="row-2">
      <div *ngFor="let step of Tools">
        <div class="card">
          <app-icons-free-tools [name]="step.icon" />
          <span>{{ step.description }}</span>
        </div>
      </div>
    </div>
  </section>

  <section
    class="container-fluid blue-area margin-top-bottom pt"
    style="position: relative; overflow-x: hidden"
  >
    <div class="container">
      <div class="row-editor">
        <div class="align-content">
          <h2 class="headings text-white">
            Technology Behind GrammarIn Proofreader
          </h2>
          <p class="paragraph text-white">
            The online proofreader operates using advanced linguistic algorithms
            and artificial intelligence. These technologies work together to
            analyze text for errors by recognizing patterns and understanding
            the context of words and phrases.
          </p>

          <p></p>

          <p class="paragraph text-white">
            It is based on machine learning models that are trained on extensive
            datasets. These models allow free proofreading to provide accurate
            suggestions tailored to the text's tone and structure. Natural
            language processing (NLP) also ensures the tool can evaluate complex
            sentence constructions and offer precise corrections.
          </p>
        </div>
        <div>
          <img
            src="/assets/images/proof-reader/editor.webp"
            alt="editor"
            height="415"
            width="746"
            class="reader"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>

  <section class="container margin-top-bottom">
    <div class="row text-center justify-content-center">
      <div class="col-lg-9 col-12 mb-4">
        <h2 class="headings">Benefits of Using Our Proofreading Tool</h2>
        <p class="paragraph">
          The importance of proofreading in writing cannot be emphasized much.
          It helps in editing and proofreading various mistakes in written
          content. Here is what it offers to the end users.
        </p>
      </div>
    </div>
    <div class="row-7">
      <div *ngFor="let section of CG">
        <div class="card-1-1">
          <app-icons-free-tools [name]="section.icon" />
          <h3 class="card-1h2">{{ section.title }}</h3>
          <p class="description" [innerHTML]="section.description"></p>
        </div>
      </div>
    </div>
    <div class="row-8">
      <div *ngFor="let section of EDU">
        <div class="card-1-1">
          <app-icons-free-tools [name]="section.icon" />
          <h3 class="card-1h2">{{ section.title }}</h3>
          <p class="description" [innerHTML]="section.description"></p>
        </div>
      </div>
    </div>
  </section>

  <section
    class="container margin-top-bottom text-center justify-content-center"
  >
    <div class="sm-scrn">
      <div class="row-6 manual-area">
        <h2 class="headings">Manual Proofreading Vs. Online Proofreader</h2>

        <p class="manual-description">
          Manual proofreading demands time, patience, and a sharp eye for detail
          but may lack efficiency. The drawbacks of manual proofreading include
          missed errors and a slower editing process, especially when handling
          lengthy or complex documents.
          <br />
          On the other hand, an online proofreader takes the hassle out of
          editing. It analyzes your text instantly and provides real-time
          suggestions for error corrections. The online proofreader ensures
          faster, more accurate results with advanced technology and
          user-friendly features. Moreover, it gives a polished final draft
          without the stress of manual corrections.
        </p>
      </div>
    </div>
  </section>

  <section class="container margin-top-bottom">
    <div class="row-10">
      <div class="row-9">
        <div *ngFor="let section of sections">
          <h2 class="headings sm-screen mt-3">{{ section.title }}</h2>
          <p class="description sm-screen">{{ section.description }}</p>
        </div>
      </div>

      <div class="easy-paper-container">
        <div
          *ngFor="let paper of easyPaper"
          class="easy-paper-item"
          [ngClass]="{
            'essay-proofreader': paper.title === 'Essay Proofreader',
            'paper-proofreader': paper.title === 'Paper Proofreader'
          }"
        >
          <h3 class="easy-reader">{{ paper.title }}</h3>
          <p class="paper-reader">{{ paper.description }}</p>
        </div>
      </div>
    </div>
  </section>

  <section class="container margin-top-bottom">
    <div class="row text-center justify-content-center">
      <div class="col-lg-9 col-md-9 mb-4">
        <h2 class="headings">GrammarIn Online Proofreader for Everyone</h2>
      </div>
      <div class="col-lg-10 col-12">
        <p class="description">
          <a href="/online-proofreader">GrammarIn's proofreader </a> is a
          versatile tool designed to meet every writer's needs, regardless of
          their skill level or purpose. The tool adapts to your unique style and
          requirements, regardless of genre. Its intuitive interface ensures
          that beginners can use it effortlessly. Moreover, its advanced
          features cater to seasoned writers seeking precision. GrammarIn truly
          lives up to its promise of being a proofreader for everyone by
          simplifying the proofreading process and making it accessible to all.
        </p>
      </div>
    </div>
  </section>

  <section
    class="container margin-top-bottom text-center justify-content-center"
  >
    <div class="row-3">
      <div *ngFor="let card of cards3">
        <div class="card-3">
          <app-icons-free-tools [name]="card.icon" />
          <h3 class="card-3-heading pt-2">{{ card.heading }}</h3>
          <span class="card-3-span">{{ card.description }}</span>
        </div>
      </div>
    </div>
  </section>

  <section class="container-fluid blue-area margin-top-bottom py-5">
    <div class="container">
      <div class="row text-center justify-content-center">
        <div class="col-lg-8 col-12 mb-4">
          <h2 class="headings text-white">
            Beneficiaries of Online Proofreader
          </h2>
          <p class="description text-white">
            The proofreader online is developed to help people improve their
            written material in a breeze. A few beneficiaries of our tool are
            mentioned below:
          </p>
        </div>
      </div>
      <div class="row-4">
        <div *ngFor="let card of TWCF" class="sm-screen">
          <span class="bgw"> <app-icons-free-tools [name]="card.icon" /></span>
          <h3 class="heading-TWCF">{{ card.heading }}</h3>
          <span class="paper-reader">{{ card.description }}</span>
        </div>
      </div>
    </div>
  </section>

  <section class="container margin-top-bottom">
    <div class="row text-center justify-content-center">
      <div class="col-lg-9 col-12 mb-4">
        <h2 class="headings">Your Guide to Proofreading</h2>
        <p class="paragraph">
          Unlock your full potential as a proofreader with these engaging guides
          on the mechanics of writing.
        </p>
      </div>
    </div>

    <div class="row">
      <div
        class="col-lg-4 col-md-6 col-12 mt-4"
        *ngFor="let card of guideToProofreading"
      >
        <div class="card-1">
          <h3 class="card-1h2 mb-4">{{ card.title }}</h3>
          <ul>
            <li *ngFor="let item of card.items" class="li-decore">
              {{ item.name }}
              <a [href]="item.href" class="a-style">
                <app-icons-free-tools [name]="card.icon" />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="fqa margin-top-bottom">
    <div class="container">
      <div class="row text-center justify-content-center">
        <div class="col-lg-9 col-12 mb-4">
          <h2 class="headings">
            Frequently Asked Questions Related to Editing and Proofreading
          </h2>
        </div>
      </div>

      <div class="v-pills-tab-list">
        <div class="" id="row_faqs">
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <div
              class="container container-grid"
              style="width: min(100% - 40px, 768px)"
            >
              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q1' }"
                (click)="toggleTab('q1')"
                id="v-pills-first-tab"
                aria-controls="q1"
                aria-expanded="false"
              >
                <div class="nav-linkFAQ">
                  <h3 class="card-header" [class.closed]="activeTab !== 'q1'">
                    What Is a Proofreader?
                  </h3>
                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q1'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q1'"
                  />
                </div>

                <div
                  aria-labelledby="q1"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q1' }"
                  id="q1"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    A proofreader is a tool that reviews written content to
                    identify and correct grammar, spelling, punctuation, and
                    formatting errors. It ensures the text is polished, precise,
                    and error-free.
                  </div>
                </div>
              </div>

              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q2' }"
                (click)="toggleTab('q2')"
                id="v-pills-2nd-tab"
                aria-controls="q2"
                aria-expanded="false"
              >
                <div class="d-flex nav-linkFAQ">
                  <h3 class="card-header" [class.closed]="activeTab !== 'q2'">
                    How Can I Proofread My Paper Online?
                  </h3>

                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q2'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q2'"
                  />
                </div>

                <div
                  aria-labelledby="q2"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q2' }"
                  id="q2"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    You can proofread your paper online by uploading or pasting
                    your text into an online proofreader. The tool will analyze
                    your paper, highlight errors, and provide suggestions for
                    improvement.
                  </div>
                </div>
              </div>

              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q3' }"
                (click)="toggleTab('q3')"
                id="v-pills-3rd-tab"
                aria-controls="q3"
                aria-expanded="false"
              >
                <div class="nav-linkFAQ">
                  <h3 class="card-header" [class.closed]="activeTab !== 'q3'">
                    Can I Proofread My Essay Using This Proofreading Tool?
                  </h3>

                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q3'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q3'"
                  />
                </div>

                <div
                  aria-labelledby="q3"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q3' }"
                  id="q3"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    Yes, our proofreading tool is designed to handle various
                    types of writing, including essays.
                  </div>
                </div>
              </div>

              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q4' }"
                (click)="toggleTab('q4')"
                id="v-pills-4th-tab"
                aria-controls="q4"
                aria-expanded="false"
              >
                <div class="nav-linkFAQ">
                  <h3
                    class="card-header faqHeading"
                    [class.closed]="activeTab !== 'q4'"
                  >
                    How Reliable Is This Free Proofreading Tool for Writing?
                  </h3>

                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q4'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q4'"
                  />
                </div>

                <div
                  aria-labelledby="q4"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q4' }"
                  id="q4"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    This free proofreading tool is highly reliable as it uses
                    advanced algorithms to detect errors accurately.
                  </div>
                </div>
              </div>

              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q5' }"
                (click)="toggleTab('q5')"
                id="v-pills-5th-tab"
                aria-controls="q5"
                aria-expanded="false"
              >
                <div class="nav-linkFAQ">
                  <h3
                    class="card-header faqHeading"
                    [class.closed]="activeTab !== 'q5'"
                  >
                    What Kinds of Mistakes Can This Proofreading Tool Catch and
                    Correct?
                  </h3>

                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q5'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q5'"
                  />
                </div>

                <div
                  aria-labelledby="q5"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q5' }"
                  id="q5"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    Our proofreading website can catch and correct all types of
                    writing errors, especially grammar, spelling, punctuation,
                    and even sentence structure problems.
                  </div>
                </div>
              </div>

              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q6' }"
                (click)="toggleTab('q6')"
                id="v-pills-6th-tab"
                aria-controls="q6"
                aria-expanded="false"
              >
                <div class="nav-linkFAQ">
                  <h3
                    class="card-header faqHeading"
                    [class.closed]="activeTab !== 'q6'"
                  >
                    Is This Editing and Proofreading Tool Legal to Use?
                  </h3>

                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q6'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q6'"
                  />
                </div>

                <div
                  aria-labelledby="q6"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q6' }"
                  id="q6"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    Yes, using this editing and proofreading tool is entirely
                    legal. It's a writing assistant designed to enhance your
                    text while maintaining content ownership.
                  </div>
                </div>
              </div>

              <div
                class="nav-link nav-pills"
                [ngClass]="{ active: activeTab === 'q7' }"
                (click)="toggleTab('q7')"
                id="v-pills-7th-tab"
                aria-controls="q7"
                aria-expanded="false"
              >
                <div class="nav-linkFAQ">
                  <h3
                    class="card-header faqHeading"
                    [class.closed]="activeTab !== 'q7'"
                  >
                    Do I Need to Register to Access This Free Online
                    Proofreader?
                  </h3>
                  <app-icons-free-tools
                    name="plusIcon"
                    *ngIf="activeTab !== 'q7'"
                  />
                  <app-icons-free-tools
                    name="minusIcon"
                    *ngIf="activeTab === 'q7'"
                  />
                </div>

                <div
                  aria-labelledby="q7"
                  class="collapse"
                  [ngClass]="{ show: activeTab === 'q7' }"
                  id="q7"
                  role="tabpanel"
                  data-parent="#v-pills-tab-list"
                >
                  <div class="card-body">
                    No, you don’t need to register to access this free online
                    proofreader. Simply visit the platform, upload your text,
                    and start proofreading instantly.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
<app-feedback></app-feedback>
<div *ngIf="error" class="backdrop" id="error-22"></div>
<div *ngIf="error" class="content-div" id="error-22-cont">
  <div class="text-center" id="error-22-contInner">
    <img src="/assets/images/paraphrasing tool/alert.svg" alt="alert" />
    <div class="content-div-p">
      <p class="error mt-4" id="errorPT">
        {{ errorAlerts }}
      </p>
    </div>
    <button class="mt-5 butn-alert" (click)="closeErrorDiv()">Ok</button>
  </div>
</div>

<!-- scroll  -->
<a
  (click)="scrollToTop()"
  *ngIf="shouldShowButton"
  id="scroll-to-top"
  data-tooltip="Go to top"
>
  <app-icons-free-tools name="goToTopIcon" />
</a>

<app-premium-modal-startup />

<app-footer></app-footer>
